import { Component, OnInit } from '@angular/core';
import { Equipement } from '../../models/equipement.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { EquipementService } from '../../services/equipement.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation';
import { TypeEquipementService } from 'app/services/type-equipement.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalFormTypeEquipementComponent } from './modal-form-type-equipement/modal-form-type-equipement.component';
import { TypeEquipement } from 'app/models/typeEquipement.model';
import { UserService } from 'app/core/user/user.service';

@Component({
    selector: 'app-equipement',
    templateUrl: './equipement.component.html',
    styleUrls: ['./equipement.component.scss']
})
export class EquipementComponent implements OnInit {

    filter: string;
    sortDirection: number = -1;
    sortValue: string = '';
    equipements: Equipement[] = [];
    typesEquipements: TypeEquipement[] = [];
    isLoaded: boolean = false;
    currentEquipement: Equipement = new Equipement();
    errors: string[] = [];
    success: boolean = false;
    error: boolean = false;
    unsavedChanges: boolean = false;

    equipementForm: FormGroup;

    private routeSub: Subscription;

    constructor(
        private equipementService: EquipementService,
        private typeEquipementService: TypeEquipementService,
        private _userService: UserService,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private router: Router,
        private fuseConfirmationService: FuseConfirmationService
    ) { }

    ngOnInit(): void {
        this.getEquipements();
        this.getTypesEquipements();
        this.equipementForm = new FormGroup({
            no_equipement: new FormControl(this.currentEquipement.no_equipement, [Validators.required]),
            type_equipement_id: new FormControl(this.currentEquipement.type_equipement?.id),
            quantite: new FormControl(this.currentEquipement.quantite),
            statut: new FormControl(this.currentEquipement.statut),
        });

        // Subscribe to form value changes
        this.equipementForm.valueChanges.subscribe(() => {
            this.unsavedChanges = true;
        });
    }

    getEquipements(): void {
        this.equipementService.getEquipements().subscribe((equipement) => {
            this.equipements = equipement;
            this.isLoaded = true;
        });
    }

    getTypesEquipements(): void {
        this.typeEquipementService.getTypesEquipements().subscribe((typesEquipements) => {
            this.typesEquipements = typesEquipements;
        });
    }

    setForm() {
        if (this.currentEquipement != null) {
            this.equipementForm.patchValue({
                no_equipement: this.currentEquipement.no_equipement,
                type_equipement_id: this.currentEquipement.type_equipement?.id,
                quantite: this.currentEquipement.quantite,
                statut: this.currentEquipement.statut,
            });
        }
    }

    get f() {
        return this.equipementForm?.controls;
    }

    onFormSubmit() {
        this.success = false;
        this.error = false;
        this.equipementForm.markAllAsTouched();

        if (this.equipementForm.valid) {
            const equipement = new Equipement(this.equipementForm.value);
            if (this.currentEquipement.id != 0) {
                this.equipementService.update(equipement, this.currentEquipement.id).subscribe(
                    (response) => {
                        this.success = true;
                        this.getEquipements();
                        this.unsavedChanges = false;
                    }, (error) => { this.error = true; this.showErrors(error); }
                );
            } else {
                this.equipementService.store(equipement).subscribe(
                    (response) => {
                        this.success = true;
                        this.getEquipements();
                        this.currentEquipement = new Equipement();
                        this.unsavedChanges = false;
                    }, (error) => { this.error = true; this.showErrors(error); }
                );
            }
        }
    }

    add() {
        this.errors = [];
        if (this.currentEquipement.id != 0) {
            const equipement = new Equipement();
            equipement.id = 0;
            this.equipements.unshift(equipement);
            this.currentEquipement = equipement;
            this.equipementForm.reset();
        }
    }

    edit(id: number) {
        this.errors = [];
        if (this.equipements[0].id === 0) {
            this.equipements.shift();
        }
        if (this.currentEquipement.id == id) {
            this.currentEquipement = new Equipement();
        }
        else {
            this.equipementService.getEquipement(id).subscribe((equipement) => {
                this.currentEquipement = equipement;
                this.setForm();
            });
        }
        this.success = false;
    }

    delete(id: number): void {
        if(this.isAdmin){
            const confirmation = this.fuseConfirmationService.open({
                title: 'Suppression d\'un équipement',
                message: 'Êtes-vous certain de vouloir supprimer cet équipement',
                actions: {
                    confirm: {
                        label: 'Supprimer'
                    }
                }
            });

            confirmation.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    this.equipementService.delete(id).subscribe(
                        (response) => {
                            this.equipements = this.equipements.filter(x => x.id != id);
                        },
                        (error) => {
                            console.log(error); this.showErrors(error);
                        }
                    );
                }
            });
        }
    }

    get isAdmin(): boolean {
        return this._userService.getCurrentUser().role_id == 1;
    }

    ajouterTypeEquipement() {
        event.stopPropagation();
        const dialogRef = this.dialog.open(ModalFormTypeEquipementComponent, {
            width: '35%',
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result != undefined) {
                this.getTypesEquipements();
                this.equipementForm.patchValue({
                    type_equipement_id: result.id != null ? +result.id : null
                });
            }
        });
    }

    showErrors(error: any) {
        //Gestion des erreurs laravel
        if (error instanceof HttpErrorResponse) {
            for (const key in error.error.errors) {
                //Todo: handle error
            }
        }
        else {
            error.forEach((element) => {
                //this.toastr.error(element);
            });
        }
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }

    sortEquipement(column: string) {
        if (column !== this.sortValue && this.sortValue !== '') {
            this.sortDirection = -1;
        }

        this.equipements.sort((a, b) => {
            const aIsNumber = !isNaN(Number(a[column]));
            const bIsNumber = !isNaN(Number(b[column]));
            if (aIsNumber && bIsNumber) {
                if (this.sortDirection === 1) {
                    return Number(a[column]) - Number(b[column]);
                } else {
                    return Number(b[column]) - Number(a[column]);
                }
            }
            if (a[column] === null || a[column] === undefined || a[column] === '') {
                return 1 * this.sortDirection;
            }
            if (b[column] === null || b[column] === undefined || b[column] === '') {
                return -1 * this.sortDirection;
            }
            if (a[column] < b[column]) {
                return - this.sortDirection;
            } else if (a[column] > b[column]) {
                return this.sortDirection;
            } else {
                return 0;
            }
        });

        this.sortDirection *= -1;
        this.sortValue = column;
    }

    hasUnsavedChanges(): Observable<boolean> {
        if (this.unsavedChanges) {
            return new Observable<boolean>(observer => {
            this.fuseConfirmationService.open().afterClosed().subscribe(result => {
                if (result === 'confirmed') {
                observer.next(true);  // Allow navigation
                } else {
                observer.next(false);  // Prevent navigation
                }
                observer.complete();
            });
            });
        }
    }
}
